import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  Button,
  Input,
  Label,
} from '../ui';
import { AlertTriangle, Trash2 } from 'lucide-react';

/**
 * Modal di conferma per eliminazione account
 * Richiede password e checkbox di conferma
 */
function DeleteAccountModal({ open, onOpenChange, onConfirm, isLoading }) {
  const [password, setPassword] = useState('');
  const [understood, setUnderstood] = useState(false);

  const handleConfirm = () => {
    if (password && understood) {
      onConfirm(password);
    }
  };

  const handleOpenChange = (open) => {
    if (!open) {
      // Reset form quando si chiude
      setPassword('');
      setUnderstood(false);
    }
    onOpenChange(open);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-2 text-destructive">
            <AlertTriangle className="h-5 w-5 sm:h-6 sm:w-6 flex-shrink-0" />
            <DialogTitle className="text-base sm:text-lg">Elimina account</DialogTitle>
          </div>
          <DialogDescription className="text-sm">
            Questa azione è <strong>irreversibile</strong>. Verranno eliminati
            permanentemente:
          </DialogDescription>
        </DialogHeader>

        <div className="bg-destructive/10 border border-destructive/20 rounded-md p-3 sm:p-4 text-xs sm:text-sm space-y-1.5 sm:space-y-2">
          <ul className="list-disc pl-4 sm:pl-5 space-y-1">
            <li>Il tuo profilo e tutti i dati personali</li>
            <li>Tutti i documenti associati al tuo account</li>
            <li>Lo storico delle tue attività</li>
          </ul>
        </div>

        <div className="space-y-3 sm:space-y-4">
          <div className="space-y-2">
            <Label htmlFor="delete-password" className="text-sm">Conferma con la tua password</Label>
            <Input
              id="delete-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Inserisci la password"
              autoComplete="current-password"
              className="min-h-[44px] text-base"
            />
          </div>

          <div className="flex items-start gap-3 p-3 border border-border rounded-lg">
            <input
              type="checkbox"
              id="delete-understood"
              checked={understood}
              onChange={(e) => setUnderstood(e.target.checked)}
              className="mt-0.5 h-5 w-5 rounded border-gray-300 text-destructive focus:ring-destructive flex-shrink-0"
            />
            <label
              htmlFor="delete-understood"
              className="text-xs sm:text-sm cursor-pointer leading-relaxed"
            >
              Comprendo che questa azione è irreversibile e che tutti i miei
              dati verranno eliminati definitivamente.
            </label>
          </div>
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => handleOpenChange(false)}
            disabled={isLoading}
            className="min-h-[44px] touch-manipulation"
          >
            Annulla
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={!password || !understood}
            isLoading={isLoading}
            className="min-h-[44px] touch-manipulation"
          >
            <Trash2 className="mr-2 h-4 w-4" />
            Elimina definitivamente
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default DeleteAccountModal;
